const toggle = (function(){
    function _toggle(){
        let getAllTogglesContainer = document.querySelectorAll('.toggle');

        getAllTogglesContainer.forEach((data, index)=>{  

            let getScrollHeihgtFirtsChild = data.scrollHeight;
            let getFirtsChild = data.firstElementChild;

            data.style.maxHeight = getFirtsChild.scrollHeight + "px";

            data.addEventListener('click', ()=>{

                function reUseRemoveToggle(){
                    data.classList.remove('active');
                    getAllTogglesContainer.forEach((data)=>{
                        let heightFirtsChild = data.firstElementChild.scrollHeight;
                        data.classList.remove('active');
                        data.style.maxHeight = heightFirtsChild + "px";
                    });
                }

                if(data.classList.contains('active')){
                    reUseRemoveToggle();
                }else{
                    reUseRemoveToggle();
                    data.classList.add('active');
                    data.style.maxHeight = data.scrollHeight + 20 + "px";
                }

            });

        });

    }


    return {
        setHandlerEvents : function(){
            _toggle()
        }
    }

})();


const loadToggleHanlders = ()=>{
    toggle.setHandlerEvents()
}

export {
    loadToggleHanlders
}
